import component from './src/region-select.vue';
export default {
  install(Vue){
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/region-select/index.js